import { CustomDialog } from '../../Component/Dialog';
import { Button } from '@mui/material';
import React from 'react';

export function ComponentLimitReachedDialog(props) {
  return (
    <CustomDialog
      isOpen={props.open}
      title={`Component Limit Reached`}
      contents={
        <p>
          Your current plan allows a maximum of {props.maxComponentLimit} components per canvas. To
          add more components, please upgrade your plan.
        </p>
      }
      buttons={
        <>
          <Button onClick={props.onCloseClick} variant="outlined" color="primary">
            Close
          </Button>
          <Button onClick={props.onUpgradeClick} variant="contained" color="primary">
            Upgrade
          </Button>
        </>
      }
    />
  );
}
